"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _useHoverCycle = _interopRequireWildcard(require("web/shared/icons/useHoverCycle"));
var _useHoverNudge = _interopRequireDefault(require("web/shared/icons/useHoverNudge"));
var _ImageCandidateActions = require("web/shared/imageCandidates/ImageCandidateActions.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* One of a candidate's icon-only actions: a full circle holding a glyph that
* moves while the pointer is on it, and rests when it is not — through
* its whole cycle for a glyph whose cycle is the point, or a nudge out and
* back for a directional one, whose whole cycle would carry it out of
* frame.
*
* A blocked action stays tappable so the tap can answer with the reason
* rather than going dead: it is drawn quiet, told to assistive technology,
* and its glyph does not move.
*/
function ImageCandidateIconButton(props) {
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    pointed = _useState2[0],
    setPointed = _useState2[1];
  const moving = pointed && !props.disabled && !props.blocked;
  const cycle = (0, _useHoverCycle.default)(moving && props.motion === "cycle", _useHoverCycle.GLYPH_CYCLE_MS);
  const nudge = (0, _useHoverNudge.default)(moving && props.motion === "nudge");
  const progress = props.motion === "cycle" ? cycle : nudge;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
    type: "button",
    "aria-label": props.label,
    title: props.title,
    disabled: props.disabled,
    "aria-disabled": props.blocked ? "true" : undefined,
    onClick: props.onPress,
    onMouseEnter: () => setPointed(true),
    onMouseLeave: () => setPointed(false),
    onFocus: () => setPointed(true),
    onBlur: () => setPointed(false)
  }, stylex.props(_ImageCandidateActions.styles.action, _ImageCandidateActions.styles.iconAction, props.kind === "view" ? _ImageCandidateActions.styles.viewAction : _ImageCandidateActions.styles.deleteAction, props.blocked && _ImageCandidateActions.styles.deleteBlocked)), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
      name: props.name,
      size: "s",
      progress: progress
    })
  }));
}
var _default = exports.default = ImageCandidateIconButton;